import React, { useEffect, useState } from "react";
import { notifyError, notifySuccess } from "../../helper";
import {encode as base64_encode, decode as base64_decode} from 'base-64';
import { DAYS } from "../../constants/constants";
import client from "../../api";

const CalendarInfo = (props) => {
    const api = client();
    const [contactEmails,setContactEmails] = useState();
    const [extraInfo,setExtraInfo] = useState({});
    const [emailFromUrl, setEmailFromUrl] = useState();
    const [workDays, setWorkDays] = useState([]);
    
    const handleEmailChange = (e) => {
        window.location.href = `/campaign/calendar/${e.target.value}`;
    }

    const convertDisplayTime = (mstime) => {
        const initialTime = new Date();
        
        const midTime = new Date();
        midTime.setHours(0, 0, 0, 0);
        const midNight = midTime.getTime();
        
        initialTime.setTime(mstime * 60 * 1000 + midNight);
        
        let hours = initialTime.getHours();
        const minutes = initialTime.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
    
        hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
    
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')} ${ampm}`;
    };
    
    useEffect(()=>{
        const getContactEmails = async () => {
            try{
                const response = await api.get('/v1/mailAccount/list');
                if(response.status === 200 || response.status === 201){
                    setContactEmails(response.data.data);
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400){
                    notifyError('Bad Request. Not able to fetch Contact Emails. Please try again');
                }  
            }
        }
        if(!contactEmails){
            getContactEmails();
        }
        if(!emailFromUrl){
            setEmailFromUrl(props.email);
        }
    }, []);

    useEffect(()=>{
        const fetchPreferences = async () => {
            try{
                const response = await api.post('/v1/mailAccount/preference',{
                    email: base64_decode(props.email)
                });
                if(response.status === 200 || response.status === 201){
                    if(response.data.data.work_days !== null){
                        setWorkDays(response.data.data.work_days);
                        setExtraInfo(response.data.data);
                    }
                    
                    
                }
            } catch(error){
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Not able to fetch Preferences for given email. Please try again');
            }
        }
        
        fetchPreferences();             
        
    },[]);
    
    return(<>
        <div className="data-info">
            <div className="field-wrap">
                <label className="label-xs">Mail Account</label>
                <select className="selectbox" onChange={handleEmailChange} value={emailFromUrl}>
                    {contactEmails && contactEmails.map((row,i)=>(<option 
                        key={i} 
                        value={base64_encode(row.email)}
                        >{row.email}</option>))}
                </select>
            </div>
            <div className="box-middle-content">
                <ul>
                {DAYS.map((d,i)=>(<li 
                        key={i} 
                        className={workDays.includes(i)?'selected':''}>
                            {d.slice(0,2)}
                        </li>))}
                </ul>
                {/* <p>
                    6:00 AM to 2:00 PM (America/Los_Angeles) <br/> 
                    Send no more than 1000 emails per day <br/> 
                    Send emails as fast as possible. <br/> 
                    Pause 5 minutes between sends <br/> 
                    Send at most 10 emails at a time <br/> 
                </p> */}
                {Object.keys(extraInfo).length ? <p>
                    {convertDisplayTime(extraInfo.work_time.from_time)} to {convertDisplayTime(extraInfo.work_time.to_time)} ({extraInfo.work_time.time_zone}). <br/> 
                    Send no more than {extraInfo.work_load_capacity.max_job_in_single_day} emails per day. <br/> 
                    Send emails as {extraInfo.work_load_capacity.strategy === "send_as_fast_as_possible" ? 'fast as possible.':''}. <br/> 
                    Pause {extraInfo.work_load_capacity.minimum_time_between_job_bursts} {extraInfo.work_load_capacity.minimum_time_between_job_bursts > 1? "minutes":"minute"} between sends. <br/> 
                    Send at most {extraInfo.work_load_capacity.max_job_in_single_burst} {extraInfo.work_load_capacity.max_job_in_single_burst > 1? "emails":"email"} at a time. <br/> 
                    </p>   :''}
                
            </div>
            <div className="box-bottom-content">
                <span onClick={()=>{
                    props.setEditMode(true);
                }}>Edit Rules</span>
            </div>
        </div>
    </>);
}

export default CalendarInfo;